import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Trash2, Pencil } from 'lucide-react';
import { TRAVEL_LABELS as LABELS, formatTravelDate } from './travelLabels';

const Field = ({ label, value }) => (
  <div>
    <p className="text-sm font-semibold blue-text opacity-60">{label}</p>
    <p className="blue-text">{value || '—'}</p>
  </div>
);

export const TravelEntryCard = ({ entry: e, onDelete, onEdit }) => (
  <Card className="border-2 border-primary cream-bg" data-testid={`travel-entry-${e.id}`}>
    <CardHeader className="pb-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <CardTitle className="text-2xl blue-text">{e.guestName}</CardTitle>
          {e.isChild && (
            <span className="text-xs font-semibold uppercase tracking-wide px-2 py-1 border border-amber-500 text-amber-700 bg-amber-50 rounded" data-testid={`child-badge-${e.id}`}>
              Child
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => onEdit(e)}
            className="border-2 border-primary blue-text hover:bg-blue-50"
            data-testid={`edit-travel-entry-${e.id}`}
          >
            <Pencil className="w-4 h-4 mr-2" />
            Edit
          </Button>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => onDelete(e.id, e.guestName)}
            className="border-2 border-red-500 text-red-600 hover:bg-red-50"
            data-testid={`delete-travel-entry-${e.id}`}
          >
            <Trash2 className="w-4 h-4 mr-2" />
            Delete
          </Button>
        </div>
      </div>
    </CardHeader>
    <CardContent>
      {e.isChild ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Kids Appetizer" value={LABELS.kidsAppetizer[e.kidsAppetizer]} />
          <Field label="Kids Main Course" value={LABELS.kidsMain[e.kidsMain]} />
        </div>
      ) : e.travelMode === 'other' ? (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Field label="Phone" value={e.phone} />
        <Field label="Travel" value={`Not flying (other) — arrives ${formatTravelDate(e.arrivalDate)}`} />
        <Field label="Hotel" value={e.hotel} />
        <Field label="Cold Appetizer" value={LABELS.cold[e.coldAppetizer]} />
        <Field label="Main Course" value={LABELS.main[e.mainCourse]} />
        <Field label="Allergies" value={(e.allergies || []).map(a => a === 'other' ? e.allergiesOther : LABELS.allergy[a]).join(', ')} />
        <Field label="Drinks" value={(e.drinks || []).map(d => LABELS.drink[d]).join(', ')} />
        <Field label="Beauty Service" value={LABELS.beauty[e.beautyService]} />
        {e.comments && (
          <div className="md:col-span-3">
            <p className="text-sm font-semibold blue-text opacity-60">Comments</p>
            <p className="blue-text italic">"{e.comments}"</p>
          </div>
        )}
      </div>
      ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Field label="Phone" value={e.phone} />
        <Field label="Hotel" value={e.hotel} />
        <Field label="Arrival Airport" value={e.arrivalAirport === 'other' ? e.arrivalAirportOther : LABELS.airport[e.arrivalAirport]} />
        <Field label="Arrival" value={`${formatTravelDate(e.arrivalDate)} ${e.arrivalTime || ''} · ${e.arrivalFlight || '—'}`} />
        <Field label="Departure Airport" value={e.departureAirport === 'other' ? e.departureAirportOther : LABELS.airport[e.departureAirport]} />
        <Field label="Departure" value={`${formatTravelDate(e.departureDate)} ${e.departureTime || ''} · ${e.departureFlight || '—'}`} />
        <Field label="Transfer Airport → Hotel" value={e.transferArrival === 'other' ? e.transferArrivalOther : LABELS.transfer[e.transferArrival]} />
        <Field label="Transfer Hotel → Airport" value={e.transferDeparture === 'other' ? e.transferDepartureOther : LABELS.transfer[e.transferDeparture]} />
        <Field label="Cold Appetizer" value={LABELS.cold[e.coldAppetizer]} />
        <Field label="Main Course" value={LABELS.main[e.mainCourse]} />
        <Field label="Allergies" value={(e.allergies || []).map(a => a === 'other' ? e.allergiesOther : LABELS.allergy[a]).join(', ')} />
        <Field label="Drinks" value={(e.drinks || []).map(d => LABELS.drink[d]).join(', ')} />
        <Field label="Beauty Service" value={LABELS.beauty[e.beautyService]} />
        {e.travelingWithChild && <Field label="Travelling with Child" value={e.travelingWithChild} />}
        {e.comments && (
          <div className="md:col-span-3">
            <p className="text-sm font-semibold blue-text opacity-60">Comments</p>
            <p className="blue-text italic">"{e.comments}"</p>
          </div>
        )}
      </div>
      )}
      <div className="mt-4 pt-4 border-t border-primary">
        <p className="text-xs blue-text opacity-60">
          Submitted: {new Date(e.submittedAt).toLocaleString('en-GB')}
        </p>
      </div>
    </CardContent>
  </Card>
);
